<template>
  <div>
    <PageAllow controller="DistributionUsers" action="index" />
    <Breadcrumbs :items="items" />
    <v-slide-x-transition>
      <v-sheet class="transparent-background-color" v-show="!currentItemMode">
        <v-row dense class="mx-5">
          <v-col cols="12" sm="12" md="4">
            <v-row dense align="center" class="pa-1">
              <SearcherKeyword
                ref="keyword"
                v-model="options.keyword"
                @text="FieldsLineName = $event"
                :label="$t('DistributionUsers.Keyword')"
              />
            </v-row>
          </v-col>

          <v-col cols="12" sm="12" md="8" align-self="center">
            <v-row dense align="center" class="search-controls">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="px-0 py-0 caption font-weight-bold grey--text"
                    color="primary"
                    @click.stop="onSearch()"
                  >
                    <v-icon small class="pe-1">fa-search</v-icon>
                    {{ $t("Search.search") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.searchTip") }}</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="caption font-weight-bold grey--text"
                    @click.stop="resetSearch()"
                  >
                    <v-icon x-small class="pe-1">fa-trash-alt</v-icon>
                    {{ $t("Search.reset") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.resetTip") }}</span>
              </v-tooltip>
              <v-spacer />
              <!-- 配送线路-->
              <v-btn
                small
                color="primary"
                @click.stop="currentItemMode = 'new'"
                class="ms-1"
              >
                <v-icon x-small class="pe-1">fa-plus</v-icon>
                {{ $t("CRUD.newInfo", [$t("DistributionUsers.ObjectName")]) }}
              </v-btn>
              <!-- 导入 -->
              <v-btn
                v-if="
                  $permission.permissionAllow('DistributionUsers', 'import')
                "
                small
                color="print"
                dark
                @click.stop="ImportDialog = true"
                class="ms-1"
              >
                <v-icon x-small class="pe-1">fa-file-import</v-icon>
                {{ $t("DistributionUser.import.import") }}
              </v-btn>
            </v-row>
          </v-col>
        </v-row>

        <!-- 表格 -->
        <div class="mx-4 mb-4">
          <v-data-table
            :headers="headers"
            :items="distributionUsers"
            :options.sync="options"
            :page.sync="paging.page"
            :server-items-length="paging.count"
            multi-sort
            class="elevation-1 px-4 pt-1"
            :footer-props="$t('$config.footer-props')"
          >
            <template v-slot:header.actions="{ header }">
              {{ header.text }}
              <v-icon x-small>fa-sliders-h</v-icon>
            </template>
            <template v-slot:item.status="{ item }">
              <!-- 状态文字/颜色 -->
              <v-chip
                small
                label
                :color="item.status | lineStatusColor"
                :text-color="item.status | lineStatusTextColor"
              >
                {{ item.status | lineStatusText }}
              </v-chip>
            </template>
            <template v-slot:item.actions="{ item }">
              <!-- 查看 -->
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    small
                    v-bind="attrs"
                    v-on="on"
                    color="secondary"
                    class="px-1 me-1"
                    @click.stop="
                      currentItemMode = 'view';
                      currentItem = item;
                    "
                    >fa-file-alt
                  </v-icon>
                </template>
                <span>{{
                  $t("CRUD.viewInfo", [$t("DistributionUsers.ObjectName")])
                }}</span>
              </v-tooltip>
              <!-- 编辑 -->
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    small
                    v-bind="attrs"
                    v-on="on"
                    color="primary"
                    class="px-1 me-1"
                    @click.stop="
                      currentItemMode = 'edit';
                      currentItem = item;
                    "
                    >fa-pencil-alt
                  </v-icon>
                </template>
                <span>{{
                  $t("CRUD.editInfo", [$t("DistributionUsers.ObjectName")])
                }}</span>
              </v-tooltip>
              <!-- 删除 -->
              <v-tooltip top v-if="item.delete_flg == false">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    small
                    v-bind="attrs"
                    v-on="on"
                    color="danger"
                    class="px-1 me-1"
                    @click.stop="
                      currentItem = item;
                      deleteDialog = true;
                    "
                    >fa-trash-alt
                  </v-icon>
                </template>
                <span>{{
                  $t("CRUD.deleteInfo", [$t("DistributionUsers.ObjectName")])
                }}</span>
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    small
                    v-bind="attrs"
                    v-on="on"
                    color="print"
                    class="px-1 me-1"
                    @click.stop="
                      $router.push({
                        path: '/stocks/distribution-users/' + item.id,
                        query: { stock_id: $route.query.stock_id },
                      })
                    "
                    >fa-store
                  </v-icon>
                </template>
                <span>{{ $t("distributionStores.ObjectName") }}</span>
              </v-tooltip>
              <!-- <v-menu
                v-model="item.btnMenu"
                open-on-hover
                close-on-click
                close-on-content-click
                offset-y
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    small
                    v-bind="attrs"
                    v-on="on"
                    color="actionMore"
                    class="px-1"
                    >fa-ellipsis-v
                  </v-icon>
                </template>
                <v-list dense>
                  <v-list-item
                    @click.stop="
                      $router.push({
                        path: '/stocks/distribution-users/' + item.id,
                        query: { stock_id: $route.query.stock_id },
                      })
                    "
                  >
                    <v-list-item-title>
                      {{ $t("distributionStores.ObjectName") }}
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu> -->
            </template>
          </v-data-table>
        </div>
      </v-sheet>
    </v-slide-x-transition>
    <DialogDelete
      v-model="deleteDialog"
      :label="$t('DistributionUsers.ObjectName')"
      @confirm="
        deleteDistribution();
        deleteDialog = false;
      "
    />
    <!-- 操作跳转 -->
    <DistrictsPathDetail
      v-show="currentItemMode"
      v-model="currentItem"
      :mode="currentItemMode"
      v-on:mode="currentItemMode = $event"
      v-on:save="getDistributionFromAPI()"
    />
    <ImportExcelAlert
      v-model="ImportDialog"
      :downloadTemplateUrl="'download/template/distribution_user_shop_template.xls'"
      @import="
        excelFile = $event;
        importExcel();
      "
    />
    <ImportResultDialog
      v-model="importResultFlg"
      :items="importResult"
      @close="
        importResultFlg = false;
        getDistributionFromAPI();
      "
    />
  </div>
</template>

<script>
import PageAllow from "@/components/PageAllow";
import i18n from "@/i18n";
import Breadcrumbs from "@/components/Breadcrumbs";
// import { mapState } from "vuex";
import SearcherKeyword from "@/components/plugins/SearcherKeyword";
import DistrictsPathDetail from "./plugins/Detail";
import DialogDelete from "@/components/plugins/DialogDelete";
import distributionUsers from "@/api/distribution_users";
import ImportExcelAlert from "@/components/plugins/ImportExcelAlert";
import ImportResultDialog from "./plugins/importResultDialog";

const defaultOptions = {
  FieldsLineName: "",
  district_ids: [],
  status: [0, 1],
};

export default {
  name: "stocksContainer",
  data: () => ({
    distributionUsers: [],
    paging: {},
    options: JSON.parse(JSON.stringify(defaultOptions)),
    FieldsLineName: "",
    currentItemMode: null,
    currentItem: null,
    deleteDialog: false,
    ImportDialog: false,
    excelFile: null,
    importResultFlg: false,
    importResult: [],
  }),
  components: {
    DialogDelete,
    Breadcrumbs,
    SearcherKeyword,
    PageAllow,
    DistrictsPathDetail,
    ImportExcelAlert,
    ImportResultDialog,
  },
  computed: {
    items: () => [
      {
        text: i18n.t("Nav.home"),
        disabled: false,
        href: "/home",
      },
      {
        text: i18n.t("Nav.stockManagement"),
        disabled: false,
        href: "/stocks",
      },
      {
        text: i18n.t("Nav.stocks"),
        disabled: false,
        href: "/stocks",
      },
      {
        text: i18n.t("DistributionUsers.title"),
        disabled: true,
        href: "/stocks-containers",
      },
    ],
    headers: () => [
      {
        text: i18n.t("DistributionUsers.Fields.distribution_name"),
        align: "start",
        sortable: false,
        value: "name",
      },
      {
        text: i18n.t("DistributionUsers.Fields.distribution_note"),
        align: "start",
        sortable: false,
        value: "memo",
      },
      {
        text: i18n.t("DistributionUsers.Fields.status"),
        align: "start",
        sortable: false,
        value: "status",
      },
      {
        text:
          i18n.t("DistributionUsers.Fields.rank") +
          i18n.t("Global.brackets", [i18n.t("stockRoadway.Fields.on")]),
        align: "start",
        sortable: false,
        value: "rank",
      },
      {
        text: i18n.t("TableHeaders.actions"),
        align: "start",
        sortable: false,
        value: "actions",
      },
    ],
  },
  methods: {
    onSearch() {
      // 搜索
      this.options = Object.assign({}, this.options, {
        keyword: this.FieldsLineName,
      });
    },
    resetSearch() {
      this.options = JSON.parse(JSON.stringify(defaultOptions));
      [this.$refs.keyword].forEach((k) => {
        if (k) k.clear();
      });
    },
    getDistributionFromAPI() {
      distributionUsers
        .fetch(
          Object.assign({}, this.options, {
            stock_id: this.$route.query.stock_id,
          })
        )
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              this.distributionUsers = response.data.distributionUsers;
              this.paging = response.data.paging;
            } else if (response.data.error.code.isNoResultSet()) {
              this.options.page = 1;
            }
          }.bind(this)
        );
    },
    deleteDistribution() {
      // 弹窗 确认删除
      if (this.currentItem) {
        distributionUsers.del(this.currentItem.id).then(
          function (response) {
            if (response.data.status.isOK()) {
              this.getDistributionFromAPI(); // 删除成功重新刷新
            }
          }.bind(this)
        );
      }
    },
    importExcel() {
      this.$store.dispatch("fullscreenLoading");
      distributionUsers
        .imports(this.$route.query.stock_id, this.excelFile)
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              if (
                response.data.err_distribution_user_shops &&
                response.data.err_distribution_user_shops.length
              ) {
                this.ImportDialog = false;
                this.importResultFlg = true;
                this.importResult = response.data.err_distribution_user_shops;
              } else {
                this.$snackbar.info(i18n.t("DistributionUser.import.success"));
                this.ImportDialog = false;
                this.getDistributionFromAPI();
              }
            }
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        )
        .catch(
          function () {
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        );
    },
  },
  watch: {
    options: {
      deep: true,
      handler() {
        this.getDistributionFromAPI();
        sessionStorage.setItem(
          "distributionUsers-options",
          JSON.stringify(this.options)
        );
      },
    },
    currentItem: {
      handler() {
        if (this.currentItem) {
          this.$cacheScrollLocation();
        } else {
          this.$scrollToCachedLocation();
        }
      },
    },
    ImportDialog: {
      handler() {
        if (!this.ImportDialog && this.excelFile) {
          this.excelFile = null;
        }
      },
    },
  },
};
</script>